<template>
  <div class="phd-risk-calculator">
      <div class="container">
          <div class="row">
              <div class="col-12 h-100">
                  <form @submit.prevent="hcmCalculatorFormula">
                      <h2> Hypertrophic Cardiomyopathy - Sudden Cardiac Death Risk Calculator</h2>
                      <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                          <div class="col-6 pl-0 float-left">
                          <label for="age" class="col-form-label">Age </label> 
                          <input type="text" 
                            class="form-control" id="age" placeholder="16-80"
                            v-model:value.number="age_range.value" 
                            @blur="validateAge"
                            aria-describedby="ageyears" 
                          />
                          <p class="text-danger errorMessage" role="alert" v-if="isAgeValidate"> {{ age_range.errorMessage}}</p>
                          <p class="text-danger requiredMessage" role="alert" v-if="isAgeRequired"> {{age_range.requiredMessage }}</p>
                          <p class="toolTip mt-3" role="alert" v-if="!ageToolTip">Age at evaluation in years (&#8805; 16 years of age).</p>
                          </div>
                          <div class="float-left clearfix lower">
                          <p class="float-left" id="ageyears">years</p>
                          <a aria-label="tool tip for age" class="ml-4  icon" @click="ageToolTip = !ageToolTip" key="age-input">i</a>   
                          </div>
                        </div>
                      </div>
                      <div class="form-row mb-4 align-items-center">
                          <div class="col-12">
                            <div class="col-6 pl-0 float-left">
                            <label for="mlvwt" class="col-form-label text-uppercase">
                              <span class="abbr">
                                <abbr aria-label="Maximal left ventricular wall thickness"
                                title="Maximal left ventricular wall thickness">mlvwt
                                </abbr>
                              </span>
                            </label>
                            <input 
                              type="text" class="form-control" id="mlvwt" 
                              placeholder="10-35" 
                              v-model:value.number="mlvwt_range.value"
                              @blur="validateMlvwt" 
                              aria-describedby="mm-value" 
                            />
                                <p class="text-danger errorMessage" role="alert" v-if="isMlvwtValidate"> {{
                                    mlvwt_range.errorMessage }}</p>
                                <p class="text-danger requiredMessage" role="alert" v-if="isMlvwtRequired"> {{
                                    mlvwt_range.requiredMessage }}</p>
                                <p class="toolTip mt-3" role="alert" v-if="!mlvwtToolTip">Wall thickness &#8805; 30 millimeter in
                                    any segment within the chamber by echocardiography or <span class="abbr"><abbr
                                            aria-label="Cardiovascular magnetic resonance"
                                            title="Cardiovascular magnetic resonance">CMR</abbr></span> imaging is
                                    Massive <span class="abbr"><abbr aria-label="Left ventricular hypertrophy"
                                            title="Left ventricular hypertrophy">LVH</abbr></span>; consideration
                                    for this morphologic marker is also given to borderline values of &#8805; 28 millimeter
                                    in individual patients at the discretion of the treating cardiologist.</p>
                            </div>
                            <div class="float-left clearfix lower">
                            <p class="float-left"> 
                              <abbr id="mm-value" aria-label="millimetre" title="millimetre">mm</abbr> 
                            </p> 
                            <a aria-label="tool tip for Maximal left ventricular wall thickness" class="ml-4 icon" @click="mlvwtToolTip = !mlvwtToolTip" key="mlvwt-input">i</a>
                            </div>
                          </div>
                      </div>
                      <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                          <div class="col-6 pl-0 float-left"> 
                            <label for="la-size" class="col-form-label">
                              <span class="abbr" aria-label="Left atrium">
                                <abbr title="Left atrium">LA</abbr>
                              </span>
                              Size
                              </label> 
                                  <input type="text" class="form-control"
                                  id="la-size" placeholder="28-67" v-model:value.number="lasize_range.value"
                                  @blur="validateLasize" aria-describedby="mm-value" />
                              <p class="text-danger errorMessage" role="alert" v-if="isLasizeValidate"> {{
                                  lasize_range.errorMessage }}</p>
                              <p class="text-danger requiredMessage" role="alert" v-if="isLasizeRequired"> {{
                                  lasize_range.requiredMessage }}</p>
                              <p class="toolTip mt-3" role="alert" v-if="!lasizeToolTip">Echocardiographic continuous-wave
                                  Doppler technique for left atrial diameter size in millimeters.</p>
                          </div>
                          <div class=" float-left clearfix lower"> 
                            <span class="float-left">mm</span> 
                            <a aria-label="tool tip for Left atrium diameter size" class="ml-4 icon" @click="lasizeToolTip = !lasizeToolTip" key="lasize-input">i</a>
                          </div>
                          </div>
                      </div>
                      <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                          <div class="col-6 pl-0 float-left"> 
                            <label for="max-lvot" class="col-form-label"><span class="abbr"
                                      aria-label="Maximal left ventricular outflow tract gradient"><abbr
                                          title="Maximal left ventricular outflow tract gradient">Max LVOT
                                          Gradient</abbr></span></label>
                                          <input type="text" class="form-control"
                                  id="max-lvot" placeholder="2-154" v-model:value.number="maxlvot_range.value"
                                  @blur="validateMaxlovt" aria-describedby="mmHg-value" />
                              <p class="text-danger errorMessage" role="alert" v-if="isMaxlovtValidate"> {{
                                  maxlvot_range.errorMessage }}</p>
                              <p class="text-danger requiredMessage" role="alert" v-if="isMaxlvotRequired"> {{
                                  maxlvot_range.requiredMessage }}</p>
                              <p class="toolTip mt-3" role="alert" v-if="!maxlvotToolTip">Provocative maneuvers may be
                                  necessary in patients with low or absent peak resting gradients (i.e., &#60; 30 mm
                                      Hg) to elicit the presence of <span class="abbr"><abbr
                                          aria-label="Left ventricular outflow tract obstruction"
                                          title="Left ventricular outflow tract obstruction">LVOTO</abbr></span>,
                                      particularly in patients with symptoms. Such maneuvers include standing,
                                      Valsalva strain, amyl nitrite inhalation, or exercise (fasted or
                                      postprandial), with simultaneous echocardiography performed using
                                      continuous-wave Doppler technique to document the relation of the gradient
                                      to occurrence of systolic anterior motion of the mitral valve.</p>
                          </div>
                          <div class=" float-left clearfix lower"> 
                            <span class="abbr float-left"> 
                              <abbr id="mmHg-value" aria-label="millimetre of mercury " title="millimetre of mercury ">mmHg</abbr> 
                              </span> 
                              <a aria-label="tool tip for Left ventricular outflow tract obstruction" class="ml-4 icon" @click="maxlvotToolTip = !maxlvotToolTip" key="maxlvot-input">i</a>
                          </div>
                          </div>
                      </div>
                      <fieldset class=" mt-5">
                          <legend class="sr-only">Risk Factors for Sudden Cardiac Death</legend>
                          <div class="form-group row">
                              <div class="col-4 col-form-label text-uppercase"> <span class="abbr"> <abbr
                                          id="abbrfhscd" aria-label="Family History of Sudden Cardiac Death"
                                          title="Family History of Sudden Cardiac Death">fh scd</abbr> </span></div>
                              <div class="col-8 pr-2">
                                  <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                          for="fhscd_no"> <input type="radio" name="fhscd" id="fhscd_no"
                                              autocomplete="off" v-model.number="fhscd_pick" value="0" checked
                                              aria-describedby="abbrfhscd" /> No </label> <label for="fhscd_yes"
                                          class="ml-4"> <input type="radio" name="fhscd" id="fhscd_yes"
                                              autocomplete="off" v-model.number="fhscd_pick" value="1"
                                              aria-describedby="abbrfhscd" /> Yes </label> 
                                              <a aria-label="tool tip for Family History of Sudden Cardiac Death" class="ml-4 icon"
                                          @click="fhscdToolTip = !fhscdToolTip" key="fhscd-input">i</a></div>
                              </div>
                              <div class="col-6">
                                  <p class="toolTip" role="alert" v-if="!fhscdToolTip">Sudden death judged definitively or likely
                                      attributable to <span class="abbr"><abbr
                                              aria-label="Hypertrophic cardiomyopathy"
                                              title="Hypertrophic cardiomyopathy">HCM</abbr></span> in &#8805; 1
                                      first-degree or close relatives who are &#8804; 50 years of age. Close relatives
                                          would generally be second-degree relatives; however, multiple SCDs in
                                          tertiary relatives should also be considered relevant.</p>
                              </div>
                          </div>
                          <div class="form-group row">
                              <div class="col-4 col-form-label text-uppercase"> <span class="abbr"> <abbr
                                          id="abbrnsvt" aria-label="Non-sustained ventricular tachycardia"
                                          title="Non-sustained ventricular tachycardia">nsvt</abbr> </span></div>
                              <div class="col-8 pr-2">
                                  <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                          for="nsvt_no"> <input type="radio" name="nsvt" id="nsvt_no"
                                              autocomplete="off" v-model.number="nsvt_pick" value="0" checked
                                              aria-describedby="abbrnsvt" /> No </label> <label for="nsvt_yes"
                                          class="ml-4"> <input type="radio" name="nsvt" id="nsvt_yes"
                                              autocomplete="off" v-model.number="nsvt_pick" value="1"
                                              aria-describedby="abbrnsvt" /> Yes </label> <a aria-label="tool tip for Non-sustained ventricular tachycardia" class="ml-4 icon"
                                          @click="nsvtToolTip = !nsvtToolTip" key="nsvt-input">i</a></div>
                              </div>
                              <div class="col-6">
                                  <p class="toolTip" role="alert" v-if="!nsvtToolTip">It would seem most appropriate to place
                                      greater weight on NSVT as a risk marker when runs are frequent (&#8805; 3), longer
                                      (&#8805; 10 beats), and faster (&#8805; 200 bpm) occurring usually over 24 to 48 hours of
                                      monitoring.</p>
                              </div>
                          </div>
                          <div class="form-group row">
                              <div class="col-4 col-form-label"> Unexplained Syncope</div>
                              <div class="col-8 pr-2">
                                  <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                          for="unexSy_no"> <input type="radio" name="unexSy" id="unexSy_no"
                                              autocomplete="off" v-model.number="unexSy_pick" value="0" checked />
                                          No </label> <label for="unexSy_yes" class="ml-4"> <input type="radio"
                                              name="unexSy" id="unexSy_yes" autocomplete="off"
                                              v-model.number="unexSy_pick" value="1" /> Yes </label> <a
                                          aria-label="tool tip for Unexplained Syncope" class="ml-4 icon" @click="unexSyToolTip = !unexSyToolTip" key="unexsy-input">i</a></div>
                              </div>
                              <div class="col-6">
                                  <p class="toolTip" role="alert" v-if="!unexSyToolTip">Greater than or equal to 1 unexplained
                                      episodes involving acute transient loss of consciousness, judged by history
                                      unlikely to be of neurocardiogenic (vasovagal) etiology, nor attributable to
                                      LVOTO, and especially when occurring within 6 months of evaluation (events
                                      beyond 5 years in the past do not appear to have relevance).</p>
                              </div>
                          </div>
                          <div class="form-group row">
                              <div class="col-4 col-form-label"> <span class="abbr"> <abbr id="abbref"
                                          aria-label="Ejection fraction"
                                          title="Ejection fraction">EF</abbr></span>
                                  &#8804; 50% 
                              </div>
                              <div class="col-8 pr-2">
                                  <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                          for="ef50_no"> <input type="radio" name="ef50" id="ef50_no"
                                              autocomplete="off" v-model.number="ef50_pick" value="0" checked
                                              aria-describedby="abbref" /> No </label> <label for="ef50_yes"
                                          class="ml-4"> <input type="radio" name="ef50" id="ef50_yes"
                                              autocomplete="off" v-model.number="ef50_pick" value="1"
                                              aria-describedby="abbref" /> Yes </label> <a aria-label="tool tip for Ejection fraction" class="ml-4 icon"
                                          @click="ef50ToolTip = !ef50ToolTip" key="ef50-iput">i</a></div>
                              </div>
                              <div class="col-6">
                                  <p class="toolTip" role="alert" v-if="!ef50ToolTip">Systolic dysfunction with EF &#8804; 50% by
                                          echocardiography or CMR.</p>
                              </div>
                          </div>
                          <div class="form-group row">
                              <div class="col-4 col-form-label">Apical Aneurysm</div>
                              <div class="col-8 pr-2">
                                  <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                          for="apAn_no"> <input type="radio" name="apAn" id="apAn_no"
                                              autocomplete="off" v-model.number="apAn_pick" value="0" checked />
                                          No </label> <label for="apAn_yes" class="ml-4"> <input type="radio"
                                              name="apAn" id="apAn_yes" autocomplete="off"
                                              v-model.number="apAn_pick" value="1" /> Yes </label> <a
                                          aria-label="tool tip for Apical Aneurysm" class="ml-4 icon" @click="apAnToolTip = !apAnToolTip" key="apan-input">i</a></div>
                              </div>
                              <div class="col-6">
                                  <p class="toolTip" role="alert" v-if="!apAnToolTip">Discrete thin-walled dyskinetic or akinetic
                                      segment of the most distal portion of the LV chamber; independent of size.
                                  </p>
                              </div>
                          </div>
                          <div class="form-group row">
                              <div class="col-4 col-form-label">Extensive <span class="abbr"> <abbr
                                          aria-label="Late gadolinium enhancement" id="abbr-elge"
                                          title="Late gadolinium enhancement">LGE</abbr></span>
                              </div>
                              <div class="col-8 pr-2">
                                  <div class="btn-group btn-group-toggle" data-toggle="buttons"> 
                                    <label for="elge_no"> <input type="radio" name="elge" id="elge_no"
                                              autocomplete="off" v-model.number="elge_pick" value="0" checked
                                              aria-describedby="abbr-elge" /> No 
                                       </label> 
                                    <label for="elge_yes" class="ml-4"> 
                                      <input type="radio" name="elge" id="elge_yes" autocomplete="off" v-model.number="elge_pick" value="1"
                                              aria-describedby="abbr-elge" /> Yes 
                                    </label> 
                                    <a aria-label="tool tip for Extensive Late gadolinium enhancement" class="ml-4 icon"
                                          @click="elgeToolTip = !elgeToolTip" key="elge-input">i</a>
                                  </div>
                              </div>
                              <div class="col-6">
                                  <p class="toolTip" role="alert" v-if="!elgeToolTip">Diffuse and extensive LGE, representing
                                      fibrosis, either quantified or estimated by visual inspection, comprising &#8805;
                                      15% of LV mass.</p>
                              </div>
                          </div>
                      </fieldset>
                      <div class="form-group"> 
                        <label for="risk" class=" col-form-label">Risk of <span
                                  class="abbr"> <abbr id="abbr-scd" aria-label="Sudden Cardiac Death"
                                      title="Sudden Cardiac Death">SCD</abbr></span> at 5 years(%)</sup> </label>
                          <div>
                              <div id="risk" v-html="risk.value" aria-describedby="abbr-scd"></div>
                          </div>
                      </div>
                      <div class="form-group"> <label for="recommendation">Recommendation</label>
                          <div id="recommendation" v-html="recommendation"></div>
                      </div>
                      <div class="form-group row">
                          <div class="col col-md-12 text-center text-lg-left"> 
                            <input class="btn btn-primary" @click="formValidate" type="submit" value="Submit" key="submit"> 
                            <input class="btn btn-outline ml-3" @click="resetForm" type="reset" key="reset"
                                  value="Reset"></div>
                      </div>
                  </form>
              </div>
              <div class="col-12">
                <p>This calculator is for use in patients with hypertrophic cardiomyopathy (HCM) who are &#8805; 16 years of age with > 1 major SCD risk factors, estimating 5-year SCD risk may aid patients in understanding the magnitude of their individual risk for SCD to further assist in ICD decision-making.</p>
<p>ICD decisions in pediatric patients with HCM are based on &#8805; 1 of these major risk factors: family history of HCM SCD, NSVT on ambulatory monitor, massive left ventricular hypertrophy, and unexplained syncope.</p>
<p>Children who are 16 to 18 years of age accounted for 2% of the cohort used for the adult-based risk calculator. The low representation of this age group should be considered if calculating risk estimates for patients in this age range.</p>
<p>The HCM-SCD Calculator should not be used in:</p>
<ul>
  <li>Pediatric patients (&#60; 16 years)</li>
  <li>Elite/competitive athletes</li>
  <li>HCM associated with metabolic diseases (e.g., Anderson-Fabry disease), and syndromes (e.g., Noonan syndrome).</li>
  <li>Patients with a previous history of aborted SCD or sustained ventricular arrhythmia who should be treated with an ICD for secondary prevention.</li>
</ul>
<p>Caution should be exercised when assessing the SCD in patients following invasive reduction in left ventricular outflow tract obstruction with myectomy or alcohol septal ablation.</p>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAgeValidate: false,
      isMlvwtValidate: false,
      isLasizeValidate: false,
      isMaxlovtValidate: false,
      isAgeRequired: false,
      isMlvwtRequired: false,
      isLasizeRequired: false,
      isMaxlvotRequired: false,
      ageToolTip: true,
      mlvwtToolTip: true,
      lasizeToolTip: true,
      maxlvotToolTip: true,
      fhscdToolTip: true,
      nsvtToolTip: true,
      unexSyToolTip: true,
      ef50ToolTip: true,
      apAnToolTip: true,
      elgeToolTip: true,
      age_range: {
        value: "",
        ageRange: {
          min: 16,
          max: 80,
        },
        requiredMessage: "Please enter your age",
        errorMessage: "Age input should be between 16 to 80 years.",
      },
      mlvwt_range: {
        value: "",
        wallThickness: {
          min: 10,
          max: 35,
        },
        requiredMessage: "Please enter the wall thickness",
        errorMessage:
          "Maximal wall thickness input should be between 10mm and 35mm.",
      },
      lasize_range: {
        value: "",
        laDiameter: {
          min: 28,
          max: 67,
        },
        requiredMessage: "Please enter the LA Diameter",
        errorMessage: "LA Diameter input should be between 28mm and 67mm.",
      },
      maxlvot_range: {
        value: "",
        lvotGradient: {
          min: 2,
          max: 154,
        },
        requiredMessage: "Please enter the LVOT Gradient",
        errorMessage:
          "LVOT Gradient input should be between 2mmHg and 154mmHg.",
      },
      fhscd_pick: 0,
      nsvt_pick: 0,
      unexSy_pick: 0,
      ef50_pick: 0,
      apAn_pick: 0,
      elge_pick: 0,
      recommendation: "",
      risk: {
        value: "",
      },
    };
  },
  methods: {
    hcmCalculatorFormula() {
      const age = this.age_range;
      const mlvwt = this.mlvwt_range;
      const lasize = this.lasize_range;
      const maxlvot = this.maxlvot_range;
      const fhscd = this.fhscd_pick;
      const nsvt = this.nsvt_pick;
      const unexSyncope = this.unexSy_pick;
      const ef50 = this.ef50_pick;
      const aa = this.apAn_pick;
      const elge = this.elge_pick;

      let a = 0.01799934 * age.value;
      let b = 0.15939858 * mlvwt.value - 0.00294271 * mlvwt.value * mlvwt.value;
      let c = 0.0259082 * lasize.value;
      let d = 0.00446131 * maxlvot.value;
      let e = fhscd === 0 ? 0 : 0.4583082;
      let f = nsvt === 0 ? 0 : 0.82639195;
      let g = unexSyncope === 0 ? 0 : 0.71650361;
      let h = mlvwt.value <= 29 ? 0 : 1;
      let i = ef50 === 0 ? 0 : 1;
      let j = null;
      let k = b + c + d + e + f + g - a;
      let l = Math.pow(2.71828183, k);
      let m = Math.pow(0.998, l);
      let risk = 100 * (1 - m);

      var elgeYes = elge == 1;
      var aaYes = aa == 1;
      var efYes = i == 1;
      var nsvtYes = f == 0.82639195;
      var fhscdYes = e == 0.4583082;
      var usYes = g == 0.71650361;
      var mlvwtYes = h == 1;

      switch (true) {
        //Class 2A: When one parameter AND NSVT AND Extensive LGE = YES
        case elgeYes && nsvtYes && aaYes && efYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%, Apical Aneurysm, and Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("elge, aa, ef & nsvt are yes");
          break;
        case efYes && nsvtYes && elgeYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("elge & nsvt");
          break;
        case aaYes && nsvtYes && elgeYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("elge & nsvt");
          break;
        case fhscdYes && nsvtYes && elgeYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("fhscd, elge, nsvt are yes");
          break;
        case usYes && nsvtYes && elgeYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("US, elge, nsvt are yes");
          break;
        case mlvwtYes && nsvtYes && elgeYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("mlvwt, elge, nsvt are yes");
          break;
        case elgeYes && efYes && aaYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm, EF ≤ 50% and Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("elge,ef,aa are yes");
          break;
        case nsvtYes && efYes && aaYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Apical Aneursym)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("elge,ef,aa are yes");
          break;

        //Class 2B(a): When all parameters = NO except for NVST AND Extensive LGE
        case elgeYes && nsvtYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
            (this.recommendation =
              "This patient has 2 risk factors that while individually carry Class 2B indications, having both of these likely represents more risk than having either risk factor in isolation");
          console.log("elge & nsvt");
          break;

        //Class 2A: When any parameter AND EXTENSIVE LGE = YES
        case elgeYes && aaYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("switch elge & aa");
          break;
        case elgeYes && efYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("elge & ef are yes");
          break;
        case elgeYes && fhscdYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("FHSCD and ELGE are yes");
          break;
        case elgeYes && usYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("Unexplained Syncope and ELGE are yes");
          break;
        case elgeYes && mlvwtYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("MLVWT and ELGE are yes");
          break;

        //Class 2A: When any parameter AND NVST = YES
        case nsvtYes && efYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("EF and NSVT are yes");
          break;
        case nsvtYes && aaYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("EF and NSVT are yes");
          break;
        case nsvtYes && fhscdYes:
          (this.risk.value = risk.toFixed(2)),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("FHSCD and NSVT are yes");
          break;
        case nsvtYes && usYes:
          (this.risk.value = risk.toFixed(2)),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("Unexplained Syncope and NSVT are yes");
          break;
        case nsvtYes && mlvwtYes:
          (this.risk.value = risk.toFixed(2)),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("MLVWT and NSVT are yes");
          break;

        //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
        case efYes && aaYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and EF ≤ 50%)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("EF and AA are yes");
          break;

        //Class 2B: When all parameters = NO except for NVST OR Extensive LGE
        case nsvtYes:
          (this.risk.value = risk.toFixed(2)),
            (this.recommendation =
              "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)");
          console.log("nsvtYes");
          break;
        case elgeYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
            (this.recommendation =
              "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)");
          console.log("elge catch all");
          break;

        //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
        case efYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("EF is Yes");
          break;
        case aaYes:
          (this.risk.value =
            risk.toFixed(2) +
            " " +
            "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)"),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("Apical aneurysm is yes");
          break;
        case fhscdYes:
          (this.risk.value = risk.toFixed(2)),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("fhscd is yes");
          break;
        case usYes:
          (this.risk.value = risk.toFixed(2)),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("Unexplained Syncope is Yes");
          break;
        case mlvwtYes:
          (this.risk.value = risk.toFixed(2)),
            (this.recommendation =
              "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
          console.log("mlvwt is yes");
          break;
        default:
          (this.risk.value = risk.toFixed(2)),
            (this.recommendation =
              "Based on the absence of risk factors, this patient does not have an indication for an  <span class='abbr' title='Implantable Cardioverter Defibrillator'><abbr title='Implantable Cardioverter Defibrillator'>ICD</abbr></span>  (Class 3 – No Benefit)");
          console.log("all no");
          break;
      }
    },

    validateAge() {
      if (
        this.age_range.value >= this.age_range.ageRange.min &&
        this.age_range.value <= this.age_range.ageRange.max
      ) {
        console.log("within range");
        this.isAgeValidate = false;
      } else {
        console.log("outside range");
        this.isAgeValidate = true;
      }
    },

    validateMlvwt() {
      if (
        this.mlvwt_range.value >= this.mlvwt_range.wallThickness.min &&
        this.mlvwt_range.value <= this.mlvwt_range.wallThickness.max
      ) {
        console.log("within range");
        this.isMlvwtValidate = false;
      } else {
        console.log("outside range");
        this.isMlvwtValidate = true;
      }
    },

    validateLasize() {
      if (
        this.lasize_range.value >= this.lasize_range.laDiameter.min &&
        this.lasize_range.value <= this.lasize_range.laDiameter.max
      ) {
        console.log("within range");
        this.isLasizeValidate = false;
      } else {
        console.log("outside range");
        this.isLasizeValidate = true;
      }
    },

    validateMaxlovt() {
      if (
        this.maxlvot_range.value >= this.maxlvot_range.lvotGradient.min &&
        this.maxlvot_range.value <= this.maxlvot_range.lvotGradient.max
      ) {
        console.log("within range");
        this.isMaxlovtValidate = false;
      } else {
        console.log("outside range");
        this.isMaxlovtValidate = true;
      }
    },

    formValidate(e) {
      if (this.age_range.value == "") {
        this.isAgeRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isAgeRequired = false;
        console.log("number entered");
      }

      if (this.mlvwt_range.value == "") {
        this.isMlvwtRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isMlvwtRequired = false;
        console.log("number entered");
      }

      if (this.lasize_range.value == "") {
        this.isLasizeRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isLasizeRequired = false;
        console.log("number  entered");
      }

      if (this.maxlvot_range.value == "") {
        this.isMaxlvotRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isMaxlvotRequired = false;
        console.log("number entered");
      }
    },

    resetForm() {
      this.age_range.value = "";
      this.mlvwt_range.value = "";
      this.lasize_range.value = "";
      this.maxlvot_range.value = "";
      this.fhscd_pick = 0;
      this.nsvt_pick = 0;
      this.unexSy_pick = 0;
      this.ef50_pick = 0;
      this.apAn_pick = 0;
      this.elge_pick = 0;
      this.risk.value = "";
      this.recommendation = "";
      this.isAgeValidate = false;
      this.isMlvwtValidate = false;
      this.isLasizeValidate = false;
      this.isMaxlovtValidate = false;
      this.isAgeRequired = false;
      this.isMlvwtRequired = false;
      this.isLasizeRequired = false;
      this.isMaxlvotRequired = false;
      this.ageToolTip = true;
      this.mlvwtToolTip = true;
      this.lasizeToolTip = true;
      this.maxlvotToolTip = true;
      this.fhscdToolTip = true;
      this.nsvtToolTip = true;
      this.unexSyToolTip = true;
      this.ef50ToolTip = true;
      this.apAnToolTip = true;
      this.elgeToolTip = true;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~@/sass/base";

textarea.form-control,
.c-aha-form textarea {
  padding: 10px;
  min-height: 100px;
}

.lower {
  margin-top: 45px;
}

@include media-breakpoint-up(sm) {
  .lower {
    margin-top: 50px;
  }
}

a.icon {
  width: 30px;
  height: 30px;
  background: #c10e21;
  border-radius: 50%;
  border: thin solid #c10e21;
  color: #fff;
  font-weight: bold;
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
a.icon:hover {
  color: #fff;
}

#risk,
#recommendation,
.toolTip {
  background-color: #e9ecef;
  opacity: 1;
  padding: 1rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-clip: padding-box;
  border: 1px solid #c4cacf;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/app/components/phd/risk-calculator.vue